import { Grid } from "@mui/material";

function EmptyOrErrorState({ title, handleClick, actionLabel, icon, marginBottom=35}) {
    return (
        <Grid
            component="span"
            container
            item
            xs={12}
            rowGap={1}
            direction="column"
            justifyContent="center"
            alignItems="center"
            mb={marginBottom}
            sx={{
                padding: "1rem",
                fontSize: "clamp(0.875rem, 2vw, 1rem)",
                textAlign: "center",
                borderRadius: "1.25rem",
                boxShadow: "0px 0px 3px 0px var(--dark-color-20)",
            }}
        >
            {icon}
            {title}
            {actionLabel && (
                <Grid
                    component="span"
                    onClick={handleClick}
                    sx={{
                        color: "var(--secondary-color)",
                        textDecoration: "underline",
                        cursor: "pointer",
                    }}
                >
                    {actionLabel}
                </Grid>
            )}
        </Grid>
    );
}

export default EmptyOrErrorState;
